
export interface FinanceRecord {
  id: number;
  date: string;
  bizType: '收购' | '销售';
  variety: string;
  quantity: number;
  unit: string;
  unitPrice: number;
  amount: number;
  revenue: number;
  cost: number;
  grossProfit: number;
  settlement: '现金' | '转账' | '承兑' | '赊账' | '支票';
  tax: number;
  taxRate: number;
  subsidy: number;
  subsidyType: string;
  counterpart: string;
  remark: string;
  // 财务扩展字段
  operatingCost: number;
  taxAmount: number;
  subsidyAmount: number;
  subsidyCategory: string;
  nature: string;
  source: string;
  // 台账 & 客户关联字段
  customerId?: number;
  contact?: string;
  phone?: string;
  idCard?: string;
  moisture?: string;
  impurity?: string;
  incomplete?: string;
}

export const initialFinanceRecords: FinanceRecord[] = [
  {
    id: 1, date: '2026-02-15', bizType: '销售', variety: '小麦', quantity: 450, unit: '吨',
    unitPrice: 2850, amount: 1282500, revenue: 1282500, cost: 1260000, grossProfit: 22500,
    settlement: '转账', tax: 38475, taxRate: 3, subsidy: 0, subsidyType: '', counterpart: '赵六面粉厂',
    remark: '', operatingCost: 1260000, taxAmount: 38475, subsidyAmount: 0, subsidyCategory: '', nature: '商品粮', source: '赵六面粉厂',
    customerId: 4, contact: '赵六', phone: '13800138004',
  },
  {
    id: 2, date: '2026-02-15', bizType: '收购', variety: '小麦', quantity: 500, unit: '吨',
    unitPrice: 2800, amount: 1400000, revenue: 0, cost: 1400000, grossProfit: 0,
    settlement: '转账', tax: 0, taxRate: 0, subsidy: 5000, subsidyType: '粮食收购补贴', counterpart: '张三农场',
    remark: '优质小麦', operatingCost: 1400000, taxAmount: 0, subsidyAmount: 5000, subsidyCategory: '粮食收购补贴', nature: '商品粮', source: '张三农场',
    customerId: 1, contact: '张三', phone: '13800138001',
  },
  {
    id: 3, date: '2026-02-14', bizType: '销售', variety: '玉米', quantity: 350, unit: '吨',
    unitPrice: 2650, amount: 927500, revenue: 927500, cost: 903000, grossProfit: 24500,
    settlement: '现金', tax: 27825, taxRate: 3, subsidy: 0, subsidyType: '', counterpart: '周八饲料厂',
    remark: '', operatingCost: 903000, taxAmount: 27825, subsidyAmount: 0, subsidyCategory: '', nature: '商品粮', source: '周八饲料厂',
    customerId: 6, contact: '周八', phone: '13800138006',
  },
  {
    id: 4, date: '2026-02-14', bizType: '收购', variety: '大米', quantity: 200, unit: '吨',
    unitPrice: 4200, amount: 840000, revenue: 0, cost: 840000, grossProfit: 0,
    settlement: '转账', tax: 0, taxRate: 0, subsidy: 8000, subsidyType: '优质粮食工程补贴', counterpart: '王五合作社',
    remark: '', operatingCost: 840000, taxAmount: 0, subsidyAmount: 8000, subsidyCategory: '优质粮食工程补贴', nature: '商品粮', source: '王五合作社',
    customerId: 3, contact: '王五', phone: '13800138003',
  },
  {
    id: 5, date: '2026-02-13', bizType: '销售', variety: '大米', quantity: 250, unit: '吨',
    unitPrice: 4300, amount: 1075000, revenue: 1075000, cost: 1050000, grossProfit: 25000,
    settlement: '现金', tax: 32250, taxRate: 3, subsidy: 0, subsidyType: '', counterpart: '郑十超市',
    remark: '精品大米', operatingCost: 1050000, taxAmount: 32250, subsidyAmount: 0, subsidyCategory: '', nature: '商品粮', source: '郑十超市',
  },
  {
    id: 6, date: '2026-02-13', bizType: '收购', variety: '大豆', quantity: 180, unit: '吨',
    unitPrice: 5200, amount: 936000, revenue: 0, cost: 936000, grossProfit: 0,
    settlement: '现金', tax: 0, taxRate: 0, subsidy: 0, subsidyType: '', counterpart: '孙七农业',
    remark: '', operatingCost: 936000, taxAmount: 0, subsidyAmount: 0, subsidyCategory: '', nature: '商品粮', source: '孙七农业',
    customerId: 5, contact: '孙七', phone: '13800138005',
  },
  {
    id: 7, date: '2026-02-12', bizType: '销售', variety: '大豆', quantity: 160, unit: '吨',
    unitPrice: 5300, amount: 848000, revenue: 848000, cost: 832000, grossProfit: 16000,
    settlement: '承兑', tax: 25440, taxRate: 3, subsidy: 0, subsidyType: '', counterpart: '陈十二油脂厂',
    remark: '', operatingCost: 832000, taxAmount: 25440, subsidyAmount: 0, subsidyCategory: '', nature: '商品粮', source: '陈十二油脂厂',
  },
  {
    id: 8, date: '2026-02-12', bizType: '收购', variety: '小麦', quantity: 600, unit: '吨',
    unitPrice: 2780, amount: 1668000, revenue: 0, cost: 1668000, grossProfit: 0,
    settlement: '转账', tax: 0, taxRate: 0, subsidy: 12000, subsidyType: '粮食收购补贴', counterpart: '吴九粮站',
    remark: '批量收购', operatingCost: 1668000, taxAmount: 0, subsidyAmount: 12000, subsidyCategory: '粮食收购补贴', nature: '商品粮', source: '吴九粮站',
  },
  {
    id: 9, date: '2026-02-11', bizType: '销售', variety: '小麦', quantity: 380, unit: '吨',
    unitPrice: 2900, amount: 1102000, revenue: 1102000, cost: 1056400, grossProfit: 45600,
    settlement: '转账', tax: 33060, taxRate: 3, subsidy: 0, subsidyType: '', counterpart: '魏十四面粉厂',
    remark: '', operatingCost: 1056400, taxAmount: 33060, subsidyAmount: 0, subsidyCategory: '', nature: '商品粮', source: '魏十四面粉厂',
  },
  {
    id: 10, date: '2026-02-10', bizType: '收购', variety: '玉米', quantity: 400, unit: '吨',
    unitPrice: 2580, amount: 1032000, revenue: 0, cost: 1032000, grossProfit: 0,
    settlement: '现金', tax: 0, taxRate: 0, subsidy: 6000, subsidyType: '粮食收购补贴', counterpart: '楚十三合作社',
    remark: '', operatingCost: 1032000, taxAmount: 0, subsidyAmount: 6000, subsidyCategory: '粮食收购补贴', nature: '商品粮', source: '楚十三合作社',
  },
  {
    id: 11, date: '2026-02-09', bizType: '销售', variety: '高粱', quantity: 120, unit: '吨',
    unitPrice: 3200, amount: 384000, revenue: 384000, cost: 372000, grossProfit: 12000,
    settlement: '转账', tax: 11520, taxRate: 3, subsidy: 0, subsidyType: '', counterpart: '白酒酿造厂',
    remark: '', operatingCost: 372000, taxAmount: 11520, subsidyAmount: 0, subsidyCategory: '', nature: '商品粮', source: '白酒酿造厂',
  },
  {
    id: 12, date: '2026-02-08', bizType: '收购', variety: '高粱', quantity: 120, unit: '吨',
    unitPrice: 3100, amount: 372000, revenue: 0, cost: 372000, grossProfit: 0,
    settlement: '转账', tax: 0, taxRate: 0, subsidy: 3600, subsidyType: '优质粮食工程补贴', counterpart: '冯十一农场',
    remark: '', operatingCost: 372000, taxAmount: 0, subsidyAmount: 3600, subsidyCategory: '优质粮食工程补贴', nature: '商品粮', source: '冯十一农场',
  },
];
